import { parseAsString, useQueryState } from 'nuqs';
import { useCallback } from 'react';

export function useAgentLogDrawerUrlState() {
  const [agentExecutionKey, setAgentExecutionKey] = useQueryState(
    'agentExecutionKey',
    parseAsString
  );

  const openDrawer = useCallback(
    (key: string) => {
      setAgentExecutionKey(key);
    },
    [setAgentExecutionKey]
  );

  const closeDrawer = useCallback(() => {
    setAgentExecutionKey(null);
  }, [setAgentExecutionKey]);

  return {
    agentExecutionKey,
    isOpen: Boolean(agentExecutionKey),
    openDrawer,
    closeDrawer
  };
}
